import styled from '@emotion/styled';
const Table = styled.ul `
  position: relative;
  display: table;
  width: ${({ theme }) => `calc(100% + ${theme.spacing[200]})`};
  margin: 0 ${({ theme }) => `calc(${theme.spacing[200]} * -1)`};
  padding: 0;
`;
const TableCell = styled.div `
  display: table-cell;
`;
const RatingTypography = styled.p `
  color: ${({ theme }) => theme.color.font.interactiveBase};
  padding: ${({ theme }) => theme.spacing[100]} 0 ${({ theme }) => theme.spacing[100]}
    ${({ theme }) => theme.spacing[200]};

  ${({ isDisabled, theme }) => isDisabled && {
    color: theme.color.font.interactiveDisabled,
}};

  ${({ isRatingScore, theme }) => isRatingScore && {
    paddingRight: theme.spacing[200],
    paddingLeft: 0,
    textAlign: 'right',
}};
`;
const TableButton = styled.button `
  position: absolute;
  z-index: 1;
  border: 1px solid transparent;
  border-radius: 4px;
  background: none;
  width: 100%;
  height: 2.8rem;
  transition: border-color 200ms ease-in-out;

  &:hover {
    border: ${({ theme, isActive }) => isActive ? '' : `1px solid ${theme.color.border.interactiveHovered}`};
    cursor: pointer;
  }

  ${({ isActive, theme }) => isActive && {
    border: `2px solid ${theme.color.border.secondary}`,
    backgroundColor: `${theme.color.background.primary}10`,
    cursor: 'pointer',
}};

  ${({ isDisabled }) => isDisabled && {
    pointerEvents: 'none',
}};
`;
export { RatingTypography, Table, TableButton, TableCell };
//# sourceMappingURL=styled.js.map